import {
    apiRequest,
    mappingKelasPegawaiCreate, 
    mappingKelasPegawaiUpdate,
    mappingKelasPegawaiEmployeeList,
    mappingKelasPegawaiGradeList,
    getPositionList,
} from "../../../../../services/adapters/kepegawaian/mappingKelasPegawaiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", mappingKelasPegawaiCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingKelasPegawaiUpdate, {
            body: query
        }, true)
    }
    
    fetchEmployeeList = async (query, cancelToken) => {
        return await apiRequest("get", mappingKelasPegawaiEmployeeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchGradeList = async (query, cancelToken) => {
        return await apiRequest("get", mappingKelasPegawaiGradeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchPositionList = async (query, cancelToken) => {
        return await apiRequest("get", getPositionList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository